import { Component, Input } from '@angular/core';
import { eachDayOfInterval, endOfMonth, startOfMonth } from 'date-fns';
import { Booking, BookingService } from 'src/app/core/booking.service';
import { ERROR_BOOKINGS_NOT_FOUND_CODE } from 'src/app/shared/constants/operationals';
import { DAYS_OF_WEEK_LABELS } from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-unit-details-calendar',
  templateUrl: './unit-details-calendar.component.html',
  styleUrls: ['./unit-details-calendar.component.scss'],
})
export class UnitDetailsCalendarComponent {
  @Input() current_month: number = new Date().getMonth();
  @Input() current_year: number = new Date().getFullYear();

  cells?: Date[];

  bookings?: Booking[];

  constructor(private booking_service: BookingService) {}

  ngOnInit(): void {
    // Setup calendar cells
    const ref_date = new Date(this.current_year, this.current_month);
    this.cells = eachDayOfInterval({
      start: startOfMonth(ref_date),
      end: endOfMonth(ref_date),
    });

    // List bookings
    this.listBookings();
  }

  listBookings(): void {
    this.booking_service.list().subscribe({
      next: response => {
        this.bookings = response;
      },
      error: error => {
        if (error?.response?.data?.code === ERROR_BOOKINGS_NOT_FOUND_CODE) {
          this.bookings = [];
        }
      },
    });
  }

  setCells(current_year: number, current_month: number): void {
    const ref_date = new Date(current_year, current_month);
    this.cells = eachDayOfInterval({
      start: startOfMonth(ref_date),
      end: endOfMonth(ref_date),
    });
  }

  getDayOfMonthNumber(cell: Date): number {
    return cell.getDate();
  }

  getDayOfWeekLabel(cell: Date): string {
    return DAYS_OF_WEEK_LABELS[cell.getUTCDay()];
  }
}
